var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 36.75V33.25C29 31.3935 28.2625 29.613 26.9497 28.3003C25.637 26.9875 23.8565 26.25 22 26.25H9.75C7.89348 26.25 6.11301 26.9875 4.80025 28.3003C3.4875 29.613 2.75 31.3935 2.75 33.25V36.75",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 19.25C19.741 19.25 22.875 16.116 22.875 12.25C22.875 8.38401 19.741 5.25 15.875 5.25C12.009 5.25 8.875 8.38401 8.875 12.25C8.875 16.116 12.009 19.25 15.875 19.25Z",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.637552ce82dea7aaecf355319c6cca6c.svg";
export { ForwardRef as ReactComponent };